import { FILTER_LIST_LIMIT } from '@/features/fanfiction-filters/consts/FILTER_CONSTANTS';
import type { FilterItem } from '@/features/fanfiction-filters/types/fanfiction-filters.types';
import { getVisibleFilterItems } from './CharacterFilterList.utils';
import { CharacterFilterItem } from './components/CharacterFilterItem';

interface CharacterFilterListProps {
  characters: FilterItem[];
  searchQuery: string;
  isShowMore: boolean;
  selectedCharacters: string[];
  selectedFandoms: string[];
  characterIdToName: Record<string, string>;
  onCharactersChange?: (characters: string[], selectedLabels?: Record<string, string>) => void;
  onSingleCharacterNavigate?: (characterId: string, fandomId: string) => void;
  onCharacterLabelCached?: (characterId: string, characterName: string) => void;
}

export const CharacterFilterList = ({
  characters,
  searchQuery,
  isShowMore,
  selectedCharacters,
  selectedFandoms,
  characterIdToName,
  onCharactersChange,
  onSingleCharacterNavigate,
  onCharacterLabelCached,
}: CharacterFilterListProps) => {
  const visibleCharacters = getVisibleFilterItems(
    characters,
    searchQuery,
    isShowMore,
    FILTER_LIST_LIMIT,
  );

  return (
    <>
      {visibleCharacters.map((item) => (
        <CharacterFilterItem
          key={`character-${item.id || item.name}`}
          item={item}
          selectedCharacters={selectedCharacters}
          selectedFandoms={selectedFandoms}
          characterIdToName={characterIdToName}
          characters={characters}
          onCharactersChange={onCharactersChange}
          onSingleCharacterNavigate={onSingleCharacterNavigate}
          onCharacterLabelCached={onCharacterLabelCached}
        />
      ))}
    </>
  );
};
